var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStoreLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_332_1503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9319 14.8371L4.5697 0.341518C4.25101 0.156468 3.85006 0.166748 3.54165 0.351799C3.22295 0.536849 3.02762 0.865828 3.02762 1.23593C3.02762 1.23593 3.0379 2.5724 3.04818 4.77245L21.5224 23.2466L29.9319 14.8371Z",
    fill: "url(#paint0_linear_332_1503)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04819 4.77246C3.07903 12.7091 3.17155 31.9749 3.21268 41.5666L21.5327 23.2467L3.04819 4.77246Z",
    fill: "url(#paint1_linear_332_1503)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4481 23.1336L29.9319 14.8372L21.5121 23.2467L31.0114 32.7459L44.4584 24.9121C44.7771 24.7271 44.9724 24.3878 44.9724 24.028C44.9724 23.6579 44.7668 23.3186 44.4481 23.1336Z",
    fill: "url(#paint2_linear_332_1503)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.20239 41.5667C3.22295 44.9901 3.23323 47.1799 3.23323 47.1799C3.23323 47.55 3.42857 47.8892 3.74726 48.064C4.06596 48.249 4.45662 48.249 4.77532 48.064L31.0216 32.7562L21.5224 23.257L3.20239 41.5667Z",
    fill: "url(#paint3_linear_332_1503)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_332_1503",
    x1: 3.02762,
    y1: 11.7318,
    x2: 29.9366,
    y2: 11.7318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63BE6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#5BBC6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB96A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_332_1503",
    x1: 3.04325,
    y1: 23.174,
    x2: 21.522,
    y2: 23.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45AFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_332_1503",
    x1: 21.522,
    y1: 23.7981,
    x2: 44.9699,
    y2: 23.7981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA51A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#FAB716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#FAC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC80F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_332_1503",
    x1: 3.20692,
    y1: 35.7295,
    x2: 31.0212,
    y2: 35.7295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC3B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7515B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_332_1503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.207886)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreLogo);
export default __webpack_public_path__ + "static/media/playStore-logo.44bb1478db8f80a7a4d150df3835ebc4.svg";
export { ForwardRef as ReactComponent };